const formatNumberWithDelimiter = (number, delimiter = ',') => {
    if (number) {
        return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${delimiter}`);
    } else {
        return '0';
    }
};

const formatThousands = n => {
    if (typeof n === 'string') return n;

    n = n || 0;

    if (n < 1000) {
        return `${n}`;
    } else if (n < 10000) {
        let thousands = String(Math.round(n / 100) / 10);
        return `${thousands}k`;
    } else {
        let thousands = String(Math.round(n / 1000));
        return `${thousands}k`;
    }
};

const formatRatio = (n, roundLimit = 10) => {
    if (n == null || typeof n == 'undefined') {
        return 'n/a';
    } else if (n < roundLimit) {
        return String(Math.round(n * 100) / 100);
    } else {
        return String(Math.floor(n));
    }
};

const formatFloatingPoint = n => {
    if (n == null || typeof n == 'undefined') {
        return 'n/a';
    } else {
        return +n.toFixed(2);
    }
};

export { formatNumberWithDelimiter, formatThousands, formatRatio, formatFloatingPoint };
